import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { AgrimotorService } from '../../agrimotor.service';

@Component({
  selector: 'app-ag-vehicle-car',
  templateUrl: './vehicle-car.component.html',
  styleUrls: ['./vehicle-car.component.css', '../../../quote.component.css']
})
export class AgVehicleCarComponent implements OnInit, OnChanges {
  @Input() vehicle;
  @Input() staticData;
  @Input() authDetails;
  @Input() modelObj;
  @Input() index;

  frmFields: FormGroup;
  submitted = false;
  showExclusions = false;

  constructor(private fb: FormBuilder, private agService: AgrimotorService) { }

  ngOnInit(): void {
    this.buildForm();
    if (this.vehicle) {
      this.patchValues();
    }
    this.frmFields.valueChanges.subscribe(val => {
      if (this.vehicle) {
        Object.assign(this.vehicle, val);
        if (val.extended_use) {
          this.vehicle.extended_use = val.extended_use;
        }
        if (val.modifications !== undefined) {
          this.vehicle.modifications = val.modifications;
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.frmFields && this.vehicle) {
      this.patchValues();
    }
  }

  buildForm() {
    this.frmFields = this.fb.group({
      registration_number: ['', Validators.required],
      make: ['', Validators.required],
      model: ['', Validators.required],
      year: ['', Validators.required],
      body_type: ['', Validators.required],
      value: ['', Validators.required],
      is_limited_use: ['', Validators.required],
      cover_type: ['', Validators.required],
      driving_restriction: ['', Validators.required],
      extended_use: this.fb.group({
        personal_business_use: [false],
        livestock_carriage: [false],
        contract_work: [false],
      }),
      annual_mileage: ['', Validators.required],
      green_card: ['', Validators.required],
      is_registered_owner: ['', Validators.required],
      ownership: [''],
      owner_name: [''],
      is_kept_overnight: ['', Validators.required],
      postcode: [''],
      tracker: ['', Validators.required],
      has_modifications: ['', Validators.required],
      modifications: this.fb.array([]),
      ncd: [''],
    });
  }

  patchValues() {
    const modsArray = this.frmFields.get('modifications') as FormArray;
    modsArray.clear();
    if (this.vehicle.modifications && this.vehicle.modifications.length) {
      this.vehicle.modifications.forEach(m => modsArray.push(this.fb.control(m)));
    }

    this.frmFields.patchValue({
      registration_number: this.vehicle.registration_number || '',
      make: this.vehicle.make || '',
      model: this.vehicle.model || '',
      year: this.vehicle.year || '',
      body_type: this.vehicle.body_type || '',
      value: this.vehicle.value || '',
      is_limited_use: this.vehicle.is_limited_use || '',
      cover_type: this.vehicle.cover_type || '',
      driving_restriction: this.vehicle.driving_restriction || '',
      extended_use: {
        personal_business_use: this.vehicle.extended_use?.personal_business_use || false,
        livestock_carriage: this.vehicle.extended_use?.livestock_carriage || false,
        contract_work: this.vehicle.extended_use?.contract_work || false,
      },
      annual_mileage: this.vehicle.annual_mileage || '',
      green_card: this.vehicle.green_card || '',
      is_registered_owner: this.vehicle.is_registered_owner || '',
      ownership: this.vehicle.ownership || '',
      owner_name: this.vehicle.owner_name || '',
      is_kept_overnight: this.vehicle.is_kept_overnight || '',
      postcode: this.vehicle.postcode || '',
      tracker: this.vehicle.tracker || '',
      has_modifications: this.vehicle.has_modifications || '',
      ncd: this.vehicle.ncd || '',
    }, { emitEvent: false });
  }

  get f() { return this.frmFields.controls; }
  get modificationsArray() { return this.frmFields.get('modifications') as FormArray; }

  addModification() {
    this.modificationsArray.push(this.fb.control(''));
  }

  removeModification(i: number) {
    this.modificationsArray.removeAt(i);
  }

  lookupVehicle() {
    const regNum = this.frmFields.get('registration_number').value;
    if (regNum) {
      this.agService.getVehicleDetails(regNum, this.authDetails)
        .subscribe((response: any) => {
          if (response.data) {
            this.frmFields.patchValue({
              make: response.data.make || '',
              model: response.data.model || '',
              year: response.data.year || '',
              value: response.data.value || '',
            });
          }
        }, () => { });
    }
  }
}
